export default "__VITE_ASSET__ev0UhKky__"